<elder-pane class="full">
  <elder-pane-header>
    <elder-pane-title>{{ 'context.order' | translate }} {{ workOrderId() }}</elder-pane-title>

    <elder-pane-actions class="layout-row gap-sm">
      <button
        mat-stroked-button
        color="primary"
        [disabled]="!workOrderId()"
        (click)="goToWorkOrder()"
      >
        {{ 'orders.work.order' | translate }}
      </button>

      <button
        mat-stroked-button
        color="primary"
        [disabled]="canChangeRoutes() === false"
        (click)="choseProductionRoutes()"
      >
        {{ 'manufacturing.routes.change' | translate }}
      </button>
    </elder-pane-actions>
  </elder-pane-header>

  <elder-pane-content class="layout-col">
    <elder-pane-subtitle class="subtitle-fix">{{
      'positions.title' | translate
    }}</elder-pane-subtitle>

    <app-work-item-utilisation-table
      class="flex"
      [workOrderId]="workOrderId()"
      [workCenterId]="workCenterId()"
      [itemConstraints]="itemConstraints()"
      [refreshContext]="contextRefreshRequest | async"
      (canChangeRoutes)="canChangeRoutes.set($event)"
    >
    </app-work-item-utilisation-table>
  </elder-pane-content>
</elder-pane>
